<template>
    <div class="testing">

        <div class="header_wrap">
            <div class="header_wrap_content">
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconshizhong mr5"></span></div>
                    <div class="header_wrap_text color_red" >
                        <span v-show="time_left!=-1" >
                            <van-count-down
                                ref="testingCountDown"
                                :time="time_left"
                                :auto-start="false"
                                @finish="bindTestingTimeOver()"
                             />
                        </span>
                        <span v-if="time_left==-1" >不计时</span>
                    </div>
                </div>
                <div class="header_wrap_item" @click="this.$refs.testingCountDown.start()">
                    <div><span class="iconfont iconkaoshi1 mr5"></span></div>
                    <div class="header_wrap_text">共 {{test_question_num}} 题</div>
                </div>
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconfenshuduan mr5"></span></div>
                    <div class="header_wrap_text">合计 {{test_score}} 分</div>
                </div>
            </div>
        </div>
        <div  v-if="test_empty==1" class="content">
            <div v-for="(item,index) in test_questions" :key="index">
                <div v-if="item.question_info.question_type==3" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(判断题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-radio-group v-model="item.user_answer">
                            <van-radio name="1" :icon-size="icon_size" >正确</van-radio>
                            <van-radio name="2" :icon-size="icon_size" >错误</van-radio>
                        </van-radio-group>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==1" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(单选题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-radio-group v-model="item.user_answer" >
                            <van-radio v-for="(options_item,options_index) in item.question_info.question_options" :key="options_index" :name="options_item.question_options_id" :icon-size="icon_size" >{{options_item.options}}</van-radio>
                        </van-radio-group>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==2" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(多选题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-checkbox-group v-model="item.user_answer">
                            <van-checkbox  v-for="(options_item,options_index) in item.question_info.question_options" :key="options_index" :name="options_item.question_options_id"  :icon-size="icon_size" shape="square">{{options_item.options}}</van-checkbox>
                        </van-checkbox-group>
                    </div>
                </div>

                <div v-if="item.question_info.question_type==4"  class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(填空题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <van-field v-for="(options_item,options_index) in item.question_info.question_options"
                            :key="options_index"
                            :name="options_item.question_options_id"
                            :label-width="label_width"
                            v-model="item.user_answer[options_index]"
                            :label="options_index+1"
                            placeholder='请输入你回答'
                        />
                    </div>
                </div>

                <div v-if="item.question_info.question_type==5" class="question_item" >
                    <div class="question_item_title" >
                        <div class="question_item_seq" >{{index+1}}、</div>
                        <div class="question_item_topic" >{{item.question_info.question}}</div>
                    </div>
                    <div class="question_item_type" >(问答题, {{item.question_info.score}}分)</div>
                    <div class="question_item_options" >
                        <div>
                            <van-field
                                v-model="item.user_answer.text"
                                rows="5"
                                autosize
                                type="textarea"
                                placeholder="请填写你的回答"
                            />
                        </div>
                        <div>
                            <div v-if="item.user_answer.type==1" class="question_essay"  >
                                <div class="iconfont_wrap" ><span @click="bindSwitchImageClick(item)"  class="iconfont iconcomiistupian mr5 size25"></span></div>
                                <div class="iconfont_wrap" @click="bindRecordClick(index)"><span class="iconfont iconyinpin mr5 size25"></span></div>
                            </div>
                            <div v-if="item.user_answer.type==2" class="question_essay_type_2">
                                <div class="essay_item_wrap" v-for="(item,index) in item.user_answer.images" :key="index" ><img  :src="item.url" alt=""></div>
                                <div class="essay_item_wrap add_img_button_wrap">
                                    <div class="add_img_button">
                                        <span class="iconfont iconxinzengtupian1 mr5 size35"></span>
                                    </div>
                                </div>
                            </div>
                            <div  v-show="item.user_answer.type==3" class="question_essay_type_3">
                                <div style="position: relative;display: inline-block;">
                                    <audio controls controlsList="nodownload">
                                        <source :src="item.user_answer.audio" type="audio/mpeg"  >
                                    </audio>
                                    <van-icon name="clear" class="remove-audio" size="20px" color="#f30" @click.stop="btnRemoveAudio" :data-index="index"/>
                                    <!--<span class="remove-audio iconfont iconguanbi"></span>-->
                                </div>
                            </div>
                            <div v-show="item.user_answer.type==4" class="question_essay_type_2">
                                <div class="task-img-li" v-for="(itemImg,indexImg) in item.user_answer.images" :key="indexImg">
                                    <img @click="previewImg" class="pub-img" :src="itemImg.url" :data-src="itemImg.url" :data-index="index"/>
                                    <span class="remove-img iconfont iconguanbi" @click.stop="btnRemoveImg" :data-index="index" :data-indexImg="indexImg" ></span>
                                </div>
                                <van-uploader
                                    :ref="item.question_info.test_question_id"
                                    v-model="item.user_answer.images"
                                    :preview-image="false"
                                    multiple
                                    :max-count="9"
                                    :after-read="bindImagesAfterRead"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <van-action-sheet v-model="record_show"  cancel-text="关闭" :closeable=false  duration="0.2" @close="closeSheet" >
                    <div class="record_content">
                        <div v-if="record_status=='未开始'" class="task-audio-recorder-time">最长不超过1分钟</div>
                        <div v-if="record_status!='未开始'" class="task-audio-recorder-time">
                            <van-count-down
                                :time="recorder_limit_time"
                                ref="countDown"
                                :auto-start="true"
                                @finish="bindRecordChange()"
                            />
                        </div>

                        <div class="audio-task-btn" >
                            <span v-if="record_status=='未开始'" @click="bindRecordStatusClick('未开始')"  class="iconfont iconyinpin color_327CE9"></span>
                            <span v-if="record_status=='录制中'" @click="bindRecordStatusClick('录制中')" class="iconfont iconbofang1 color_green"></span>
                            <span v-if="record_status=='已录制'" @click="bindRecordStatusClick('已录制')" class="iconfont iconbofang11 color_red"></span>
                        </div>

                        <div v-if="record_status=='未开始'" class="audio-task-txt">
                            点击按钮开始录制
                        </div>
                        <div v-if="record_status=='录制中'" class="audio-task-txt">
                            点击按钮结束录制
                        </div>
                        <div v-if="record_status=='已录制'" class="audio-task-event" >
                            <van-button  type="info audio-task-control" size="small" plain @click="bindRecordResetStatusClick" >重录</van-button>
                            <van-button type="info audio-task-control" size="small" plain @click="bindRecorderManagerPlay">{{isRecorderManager?'暂停':'试听'}}</van-button>
                            <van-button type="info audio-task-control" size="small" plain @click="bindRecorderManagerSave">保存</van-button>
                        </div>
                    </div>
            </van-action-sheet>
            <div>
                <van-button v-if="user_status==0" type="info" @click="bindSubmit" block>提交试卷</van-button>
            </div>
        </div>
        <van-empty v-if="test_empty==2" description="暂无考试" />

    </div>
</template>

<script>
    import { List,PullRefresh,ImagePreview,Icon,Form,Field,RadioGroup, Radio,Checkbox, CheckboxGroup,Button,Uploader, ActionSheet,CountDown,Empty,Dialog  } from 'vant';
    import wx from 'weixin-js-sdk'
    export default {
        components:{
            [Form .name]:Form,
            [Field .name]:Field,
            [RadioGroup .name]:RadioGroup,
            [Radio .name]:Radio,
            [Checkbox .name]:Checkbox,
            [CheckboxGroup .name]:CheckboxGroup,
            [Button .name]:Button,
            [Uploader .name]:Uploader,
            [ActionSheet .name]:ActionSheet,
            [CountDown .name]:CountDown,
            [Empty .name]:Empty,
            [Icon.name]:Icon,
            [Dialog  .name]:Dialog ,
        },
        data() {
            return {
                radio: false,
                checked: [],
                text: '',
                test_id: '',
                message:'',
                user_status: 0,
                icon_size: "18px",
                label_width: '15px',

                essays:[],
                essay_question_images:[],
                essay_question_type:1,

                record_show: false,
                record_status: '未开始',//未开始,录制中,已录制
                recorder_time:0,
                recorder_limit_time: 60000,

                time_left: 0,
                test_time: '00:00:00',
                test_question_num: 0,

                test_score: 0,
                test_empty: 0,
                test_questions: [],
                curr_questions_item:{},

                localId:'',
                index:0,
                isRecorderManager:false
            };
        },
        mounted() {
            this.util.hideOptionMenu();
            this.loading = true;
            this.$(document).attr('title','考试');
            this.test_id = this.$route.query.test_id
            this.getQuestion()
        },
        methods: {
            bindRecordClick(index){
                this.index = index;
                this.record_show = true;
                this.record_status = '未开始'
            },
            bindRecordStatusClick(status){
                console.log(status)
                var _self=this;
                if(status=='未开始'){
                    // this.$refs.countDown.start()
                    // this.record_status = '录制中'
                    // this.$refs.countDown.start()

                    wx.startRecord({
                        success: function(){
                            _self.record_status = '录制中'
                            _self.nextTick(()=>{
                                _self.$refs.countDown.reset()
                            })
                        },
                        cancel: function () {
                            _self.util.showToast({
                                message:'用户拒绝授权录音'
                            })
                        }
                    });
                }else if(status=='录制中'){
                    this.record_status = '已录制'
                    this.$refs.countDown.pause()

                    wx.stopRecord({
                        success: function (res) {
                            _self.onVoiceRecordEnd(res);
                        }
                    });
                }
            },
            onVoiceRecordEnd(res){
                console.log('luying',res)

                this.localId =  res.localId;
            },
            bindRecorderManagerPlay(){
                if(this.isRecorderManager){
                    wx.stopVoice({
                        localId: this.localId // 需要停止的音频的本地ID，由stopRecord接口获得
                    });
                    this.onVoicePlayEnd();
                }else{
                    this.isRecorderManager = true;
                    wx.playVoice({
                        localId: this.localId // 需要播放的音频的本地ID，由stopRecord接口获得
                    });
                    this.bindRecorderManagerEvent();
                }
            },
            onVoicePlayEnd(){
                var _self = this;
                _self.isRecorderManager = false;
            },
            bindRecorderManagerEvent:function(){
                var _self = this;

                //监听录音自动停止接口
                wx.onVoiceRecordEnd({
                    // 录音时间超过一分钟没有停止的时候会执行 complete 回调
                    complete: function (res) {

                        _self.record_status = '已录制'
                        _self.$refs.countDown.pause()
                        _self.onVoiceRecordEnd(res);
                    }
                });

                //监听语音播放完毕接口
                wx.onVoicePlayEnd({
                    success: function (res) {
                        _self.localId = res.localId; // 返回音频的本地ID
                        _self.onVoicePlayEnd();
                    }
                });
            },
            closeSheet(){
                this.isRecorderManager=false;
                this.recorder_limit_time=60000;
            },
            bindRecorderManagerSave(){
                var _self=this;
                wx.uploadVoice({
                    localId: this.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: function (res) {
                        var serverId = res.serverId; // 返回音频的服务器端ID

                        _self.util.server.api.get_wx_media({
                            data:{
                                server_id:serverId
                            },
                            callback:function (res) {

                                _self.test_questions[_self.index].user_answer.audio=res.data.url;
                                _self.test_questions[_self.index].user_answer.type=3;
                                _self.isOpenAudioMask=false;
                                _self.record_show=false;
                            }
                        })

                    }
                });
            },
            bindRecordResetStatusClick(status){
                this.record_status = '未开始'
                this.isRecorderManager=false;
                this.recorder_limit_time=60000;
            },
            bindRecordChange(timeData){
                this.record_status = '已录制'
            },
            bindSwitchImageClick(item){
                this.curr_questions_item = item
                const uploadref = item.question_info.test_question_id
                this.$refs[uploadref][0].chooseFile()
            },
            bindImagesAfterRead(e){
                var _self = this;

                e.status = 'uploading';
                e.message = '上传中...';
                if(e instanceof Array){
                    e.forEach((value,index,array) => {

                        this.util.upfile({
                            file: value.file,
                            data: {},
                            callback: res => {
                                value.status = 'done'
                                value.url = res.data.domain_url
                                value.content = '';

                                _self.curr_questions_item.user_answer.type = 4
                                _self.$forceUpdate()
                            }
                        });
                    })
                }else{
                    this.util.upfile({
                        file: e.file,
                        data: {},
                        callback: res => {
                            e.status = 'done'
                            e.url = res.data.domain_url
                            e.content = ''
                            _self.curr_questions_item.user_answer.type = 4
                            _self.$forceUpdate()
                        }
                    });
                }
            },
            //删除图片
            btnRemoveImg:function(e){
                var index= e.currentTarget.dataset.index;
                var indexImg= e.currentTarget.dataset.indexImg;
                this.test_questions[index].user_answer.images.splice(indexImg,1);
                this.curr_questions_item = this.test_questions[index];

                if(this.test_questions[index].user_answer.images.length == 0){
                    this.curr_questions_item.user_answer.type = 1
                }
            },
            btnRemoveAudio:function(e){
                var index= e.currentTarget.dataset.index;
                this.test_questions[index].user_answer.audio = '';
                this.curr_questions_item = this.test_questions[index];
                this.curr_questions_item.user_answer.type = 1
            },
            bindTestingTimeOver(){
                const _this=this;
                this.comimtAnswer(
                    function(){
                        Dialog.confirm({
                            title: '系统提示',
                            message: '哎呀，考试时间到了已为您提交答卷',
                            confirmButtonText: '立即去查看成绩',
                            showCancelButton:false
                        })
                        .then(() => {
                            _this.$router.push(_this.util.urlPrefix+'/testing/answered?test_id='+_this.test_id+'&token='+_this.util.token);
                        })
                        .catch(() => {
                            // on cancel
                        });
                    }
                );

            },
            bindSubmit(){
                const _this=this;
                Dialog.confirm({
                    title: '系统提示',
                    message: '确定提交答卷吗？提交后不能进行修改',
                })
                .then(() => {
                    this.comimtAnswer(
                        function(){
                            _this.$router.push(_this.util.urlPrefix+'/testing/answered?test_id='+_this.test_id+'&token='+_this.util.token);
                        }
                    )
                })
                .catch(() => {
                    // on cancel
                });

            },

            //图片查看
            previewImg:function(e){
                var img = e.currentTarget.dataset.src;
                var index = e.currentTarget.dataset.index;

                var startPosition = 0;
                var imgArr=[];
                for (var i =0;i<this.test_questions[index].user_answer.images.length;i++){
                    if(this.test_questions[index].user_answer.images[i].url == img){
                        startPosition = i;
                    }
                    imgArr.push(this.test_questions[index].user_answer.images[i].url)
                }

                ImagePreview({
                    images:imgArr,
                    startPosition:startPosition,
                    closeable: true
                });
            },
            comimtAnswer(cb){
                console.log(this.test_questions)
                let answers = [];
                this.test_questions.forEach((value,index,array) => {
                    let temp = {}
                    temp.test_question_id = value.question_info.test_question_id
                    temp.answer = value.user_answer
                    answers.push(temp)
                })
                console.log("222222",answers)
                //return false;
                this.util.server.mini_testing.answer({
                    data:{
                        test_id: this.test_id,
                        use_time: 5,
                        answers: answers
                    },
                    callback:(
                        res => {
                            cb(res)
                        }
                    )
                })
            },
            getQuestion(){
                var _self=this;
                this.util.server.mini_testing.get_question({
                    data:{
                        test_id: this.test_id,
                    },
                    callback:(res => {
                        if(res.data){
                            let datas = res.data;
                            console.log('length',datas.length)//data.items && data.items.length>0
                            if(datas && datas.test_info){
                                this.test_empty = 1
                                this.test_question_num = datas.test_question_num
                                this.test_score = datas.test_score
                                this.user_status = datas.user_status
                                if(datas.time_left!=-1 && datas.user_status==0){
                                    this.time_left = datas.time_left * 1000
                                    this.$nextTick(() => {
                                        _self.$refs.testingCountDown.start()
                                    })
                                    //console.log("1111",this.$refs.testingCountDown);
                                }

                                //init 初始化数据格式
                                //对于不同类型，需要初始化数据绑定
                                datas.test_info.forEach((value,index,array) => {
                                    console.log(value)
                                    //value.user_answer = '1111'
                                    //单选题
                                    if(value.question_info.question_type==1){
                                        value.user_answer = ''
                                    }
                                    //多选题
                                    if(value.question_info.question_type==2){
                                        value.user_answer = []
                                    }
                                    //判断题
                                    if(value.question_info.question_type==3){
                                        value.user_answer = ''
                                    }
                                    //填空题
                                    if(value.question_info.question_type==4){
                                        value.user_answer = new Array(value.question_info.question_options.length);
                                        value.user_answer.forEach((function(item,index,arr) {
                                            arr[index]=''
                                        }))
                                    }
                                    //问答题
                                    if(value.question_info.question_type==5){
                                        value.user_answer = {}
                                        value.user_answer.type = 1
                                        value.user_answer.images = []
                                        value.user_answer.audio = ''
                                        value.user_answer.text = ''
                                    }

                                });
                                console.log(datas.test_info)
                                this.test_questions = datas.test_info
                            }else{
                                this.test_empty = 2
                            }

                        }
                    })
                })
            }
        },
    };

</script>

<style scoped>

    body{
        background-color: #ffffff;
    }
    .testing .header_wrap{
        height: 70px;
        width: 100%;
        background-color: #ffffff;
    }
    .testing .header_wrap_content{
        padding: 15px 30px;
        display: flex;
        box-sizing:border-box;
        justify-content: space-between;
    }
    .testing .header_wrap_item{
        width: 72px;
        height: 40px;
        text-align: center;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .testing .header_wrap_text{
        font-size: 12px;
    }
    .testing .header_wrap_text .van-count-down{
        color: red;
    }
    .color_red{
        color: red;
    }
    .color_green{
        color: #07c160;
    }
    .color_327CE9{
        color: #327CE9;
    }
    .content{
        padding: 18px 15px 20px 15px;
    }
    .content .question_item{
        background-color:  #ffffff;
        padding: 18px 15px 25px 15px;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
        margin-bottom: 15px;
    }
    .question_item_title{
        display: flex;
    }
    .question_item_seq{
        width: 25px;
    }
    .question_item_topic{
        line-height: 25px;
    }
    .question_item_type{
        padding-left: 8px;
        color: #CCC;
    }
    .van-radio{
        margin-top: 20px;
    }
    .van-checkbox{
        margin-top: 20px;
    }
    .question_essay{
        display: flex;
    }
    .question_essay_type_2{
        display: flex;
        box-sizing:border-box;
        flex-wrap: wrap;
    }
    .iconfont_wrap{
        padding: 5px;
    }
    .size25{
        font-size: 25px;
    }
    .size35{
        font-size: 35px;
    }
    .essay_item_wrap{
        width: 31%;
        height: 26vw;
        padding: 5px 1%;
    }
    .essay_item_wrap img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .add_img_button{
        width: 100%;
        height: 100%;
        background-color: #CCC;
        display: flex;
        justify-content:center;
        align-items:center;
        color: aliceblue;
        cursor: pointer;
    }
    .van-action-sheet__close{
        display: none;
    }
    .record_content{
        padding: 30px;
        height: 160px;
    }
    .task-audio-recorder-time{
        text-align: center;
        font-size: 11px;
        color: #CCC ;
    }
    .audio-task-btn{
        text-align: center;
    }
    .audio-task-btn .iconfont{
        font-size: 45px;
        padding: 10px;
        background-color: #fff;
        box-shadow: 1px 0 10px #eee;
        border-radius: 50%;
        display: inline-block;
        margin-top: 10px;
    }
    .audio-task-txt{
        padding-top: 15px;
        text-align: center;
        font-size: 11px;
    }
    .audio-task-event{
        display: flex;
        justify-content: space-between;
        padding-top: 23px;
    }
    .audio-task-control{
        width: 80px;
        border-radius: 5px;
    }
    .task-img-li{
        display: inline-block;
        font-size: 0;
        margin-right: 15px;
        margin-bottom: 10px;
        position: relative;
    }
    .task-img-li .pub-img{
        width: 24vw;
        height: 24vw;
    }
    .task-img-li .remove-img{
        position: absolute;
        top: 0;
        right: 0;
        color: #f30;
        margin-top: -10px;
        margin-right: -10px;
        font-size: 20px;
    }
    .remove-audio{
        position: absolute;
        top: 0;
        right: 0;
        color: #f30;
        margin-top: -10px;
        margin-right: -10px;
        font-size: 20px;
        background-color: #fff;
        border-radius: 50%;
    }
</style>
